type Provider = 'wave' | 'orange_money'

interface Props {
  value: Provider
  onChange: (v: Provider) => void
}

const PROVIDERS: { id: Provider; label: string; color: string; bg: string; border: string }[] = [
  {
    id: 'wave',
    label: 'Wave',
    color: 'text-blue-700',
    bg: 'bg-blue-50',
    border: 'border-blue-400',
  },
  {
    id: 'orange_money',
    label: 'Orange Money',
    color: 'text-orange-700',
    bg: 'bg-orange-50',
    border: 'border-orange-400',
  },
]

export function PaymentProviderSelector({ value, onChange }: Props) {
  return (
    <div className="grid grid-cols-2 gap-3">
      {PROVIDERS.map((p) => (
        <button
          key={p.id}
          type="button"
          onClick={() => onChange(p.id)}
          className={`rounded-xl border-2 px-4 py-3 text-center transition-all duration-150 font-semibold text-sm ${
            value === p.id
              ? `${p.border} ${p.bg} ${p.color}`
              : 'border-gray-200 bg-white text-gray-600 hover:border-gray-300'
          }`}
        >
          {p.label}
        </button>
      ))}
    </div>
  )
}
